import { render } from "./IconFolder.vue?vue&type=template&id=a8c48546"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8c48546"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8c48546', __exports__)) {
    api.reload('a8c48546', __exports__)
  }
  
  module.hot.accept("./IconFolder.vue?vue&type=template&id=a8c48546", () => {
    api.rerender('a8c48546', render)
  })

}


export default __exports__